export default "__VITE_ASSET__nSGfMHSC__"